import * as React from "react";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";
import { Popover, ArrowContainer } from 'react-tiny-popover';

export const NearbySuburb = (props) => {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false)

    const { state, HandleSelectSuburb } = React.useContext(CostOfCareCalculatorContext)

    const { suburb, maxPrice, current, suburbAverage } = props

    React.useEffect(() => {
        window.addEventListener('opensuburbpopover', (event: CustomEvent) => {
            suburb.Name == event.detail.name ? setIsPopoverOpen(true) : setIsPopoverOpen(false)
        });
    })

    const OpenPopover = (name) => {
        name = name == state.suburbName ? null : name
        var evt = new CustomEvent("opensuburbpopover", { detail: { name: name } });
        window.dispatchEvent(evt);
        
    }

    const SelectSuburb = (event, suburb) => {
        event.stopPropagation()

        let suburbData = {
            value: suburb.SuburbIdHash,
            label: `${suburb.Name} (${suburb.Postcode})`,
            suburbName: suburb.Name,
            postcode: suburb.Postcode,
        }
        HandleSelectSuburb(suburbData)
    }

    return (
        <React.Fragment>
            <Popover
                isOpen={isPopoverOpen}
                positions={['top', 'bottom', 'left', 'right']} // preferred positions by priority
                content={({ position, childRect, popoverRect }) => (
                        <div
                            onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                        >
                            <div onMouseOver={() => setIsPopoverOpen(true)} onMouseLeave={() => setIsPopoverOpen(false)} className="p-6 bg-white shadow-md rounded-lg">
                                <div className="font-semibold text-lg mb-2">{suburb.Name}</div>
                                <div className="flex flex-row items-center justify-between mb-2 text-base-15">
                                    <div className="text-gray-700">Min</div>
                                    <div className="font-bold">${suburb.AverageFee.min.toFixed(2)}</div>
                                </div>
                                <div className="flex flex-row items-center justify-between mb-2 text-base-15">
                                    <div className="text-gray-700">Max</div>
                                    <div className="font-bold">${suburb.AverageFee.max.toFixed(2)}</div>
                                </div>
                                <div className="flex flex-row items-center justify-between mb-3 text-base-15">
                                    <div className="text-gray-700">Average</div>
                                    <div className="font-bold">{suburb.AverageFee.amountWithCurrency}</div>
                                </div>
                                <div><button onClick={(event) => SelectSuburb(event, suburb)} className="button cta-primary">View more</button></div>
                            </div>
                        </div>
                )}
            >
                <div className="flex flex-row justify-between items-center mb-3">
                    <div className="w-1/2" onMouseOver={() => OpenPopover(suburb.Name)} onClick={() => OpenPopover(suburb.Name)}>
                        <div className={`text-white font-bold rounded-lg w-8/12 py-1 px-2 cursor-pointer ${current ? 'bg-skin-magenta' : 'bg-skin-footer hover:bg-skin-magenta'}`} style={{ width: `${(suburb.AverageFee.amount.toFixed(0) / maxPrice.toFixed(0)) * 100}%` }}>${suburbAverage}</div>
                    </div>
                    <div className={`w-1/2 text-right font-bold underline cursor-pointer ${current ? 'text-skin-autocomplete-mark' : 'hover:text-skin-autocomplete-mark'}`} onMouseOver={() => OpenPopover(suburb.Name)} onClick={() => OpenPopover(suburb.Name)}>
                        {suburb.Name}
                    </div>
                </div>
            </Popover>
        </React.Fragment>
    );
}